module.exports = __webpack_public_path__ + "img/Address.d40b8287.svg";